<template>
	<div class="marker-action">
		<list-action-form
			ref="form"
			:ids="ids"
			:labels="labels"
			:route="route"
			:method="method"
			:button-class="buttonClass"
			:form-class="formClass"
			@submitted="submit"
		>
			<slot />
		</list-action-form>
	</div>
</template>

<script>
import $ from 'jquery';
import ListActionForm from './ListActionForm.vue';
import loader from '@/lib/loader.js';

/**
 * The base ListAction component.
 */
export default {
	components: {
		ListActionForm,
	},
	props: {
		ids: {
			type: Array,
			default: () => [],
		},
		labels: {
			type: Object,
			default: () => ({}),
		},
		route: {
			type: String,
			required: true,
		},
		method: {
			type: String,
			required: true,
		},
		buttonClass: {
			type: String,
			default: null,
		},
		formClass: {
			type: String,
			default: null,
		},
	},
	methods: {
		submit() {
			//  Forms with the ignore class will bypass PJAX and trigger a full page load
			//  These forms should display the loader during submission
			if (this.formClass?.includes('ignore')) {
				loader.showLoader();
			}

			$(this.$refs.form.$el).submit();
		},
	},
};
</script>
